import React from 'react'

import { Document } from '@contentful/rich-text-types'

import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'
import Paper from 'components_new/atoms/Paper'

import ContentfulRichTextRendered from 'components_new/molecules/ContentfulRichTextRenderer'
import { useTranslation } from 'language/translator'

interface ContentProps {
  body: Document
  hint: Document | undefined
  summary: Document
  sx?: object
}

const Content = (props: ContentProps) => {
  const { body, hint, summary, sx } = props

  const { t } = useTranslation()

  return (
    <Box sx={sx}>
      <ContentfulRichTextRendered
        component="div"
        sx={{ mb: 4 }}
        variant="subtitle1"
        value={summary}
      />

      <Text component="div" sx={{ mb: 2 }} variant="h5">
        {t('dashboards', 'why_you_should_use_dashboard_title')}
      </Text>
      <ContentfulRichTextRendered value={body} />
      {hint ? (
        <Paper sx={{ p: 4, my: 4 }} variant="outlined">
          <Text component="div" sx={{ mb: 2 }} variant="h5">
            {t('dashboards', 'tips')}
          </Text>
          <ContentfulRichTextRendered value={hint} />
        </Paper>
      ) : null}
    </Box>
  )
}

export default Content
